export function extractInternationalNumber(raw) {
  if (raw === null || raw === undefined) return null;
  // Support DynamoDB typed attribute objects { S: "+341234" }
  let s = raw;
  if (typeof raw === "object" && Object.prototype.hasOwnProperty.call(raw, "S")) {
    s = raw.S;
  }
  s = String(s || "").trim();
  if (!s) return null;

  // Try to extract the first international-ish number with + or digits
  const match = s.match(/\+?\d[\d\s\-()]{4,}\d/);
  if (match && match[0]) {
    const digits = match[0].replace(/[^0-9]+/g, "");
    if (!digits) return null;
    return `+${digits}`;
  }

  // fallback: extract all digits
  const digits = s.replace(/[^0-9]+/g, "");
  if (!digits) return null;
  return `+${digits}`;
}

export function splitCountryAndNumber(internationalStr, countriesData, fallbackCountry = "ES") {
  if (!internationalStr) return { country: fallbackCountry, number: "" };
  // Ensure + prefix
  const normalized = internationalStr.startsWith("+") ? internationalStr : `+${internationalStr}`;
  const match = (countriesData || [])
    .slice()
    .sort((a, b) => b.dial_code.length - a.dial_code.length)
    .find((c) => normalized.startsWith(c.dial_code));
  if (match) {
    return { country: match.code, number: normalized.replace(match.dial_code, "") };
  }
  return { country: fallbackCountry, number: normalized.replace(/[^0-9]/g, "") };
}
